import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { inject } from '@angular/core';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.authReady$.pipe(
    take(1),
    map(isReady => {
      if (isReady) {
        if (authService.isAuthenticated()) {
          // User is authenticated
          if (route.routeConfig?.path === 'initialize') {
            // If on the 'initialize' route and authenticated, redirect to a protected default (e.g., dashboard)
            router.navigate(['/dashboard']);
            return false; // Do not activate the 'initialize' component
          }
          return true; // Allow access to other protected routes
        } else {
          // User is NOT authenticated
          if (state.url === '/initialize' || route.routeConfig?.path === 'initialize') {
            // If on 'initialize' or trying to access a protected route while unauthenticated, redirect to Home
            router.navigate(['/home']);
            return false; // Do not activate the 'initialize' component
          }
          // If trying to access any other protected route directly while unauthenticated
          router.navigate(['/home']);
          return false;
        }
      }
      return false; // Should theoretically not be reached due to `take(1)`
    })
  );
};